import React, { FC } from "react";
import * as _ from "lodash";

import { EventEntity } from "@ctra/api";
import { DownOutlined } from "@ctra/components";
import { EventContext, GenericLabelEvent, useEvent, IdaQnAsEventExpandIcon } from "@events";

interface CustomEventExpandIconProps {
  /**
   * Angle of rotation for the icon
   */
  rotate: number;
}

/**
 * Custom event expand icon
 * @param {React.PropsWithChildren<CustomEventExpandIconProps>} props
 * @return {JSX.Element}
 * @constructor
 */
export const CustomEventExpandIcon: FC<CustomEventExpandIconProps> = ({ rotate }) => {
  /**
   * @todo figure out what to do with multiple children (when the time comes)
   */
  const {
    event: { children }
  } = useEvent<GenericLabelEvent>();

  return children.length ? (
    <EventContext.Provider eventID={(_.first(children) as EventEntity).id}>
      <IdaQnAsEventExpandIcon rotate={rotate} expanded={false} />
    </EventContext.Provider>
  ) : (
    <DownOutlined rotate={rotate} />
  );
};
